

module.exports = __webpack_require__.stylable.create(
    "buttonnext1213573794",
    {"classes":{"root":"buttonnext1213573794__root","content":"buttonnext1213573794__content","prefix":"buttonnext1213573794__prefix","suffix":"buttonnext1213573794__suffix"},"vars":{},"stVars":{},"keyframes":{}},
    ".buttonnext1213573794__root{display:inline-flex;align-items:center;cursor:pointer}.buttonnext1213573794__prefix{flex-shrink:0}.buttonnext1213573794__suffix{flex-shrink:0}.buttonnext1213573794__root.buttonnext1213573794--disabled{cursor:default}.buttonnext1213573794__root[disabled]{pointer-events:none}",
    2,
    "buttonnext1213573794",
    __webpack_require__.stylable.$
);
